<template>
    <div class="detail">
        <span v-if="detail.message.type==='ZZS'">
            {{detail.message.data&&detail.message.data.tip||'未知'}}
        </span>
    </div>
</template>
<script>
    export default {
        props:['detail'],
        data(){
            return {

            }
        },
        computed:{

        },
        methods:{
            getDetail(){

            }
        }
    }
</script>
<style scoped lang="less">
    .detail{
        position: relative;
        padding-left: 15px;

        .tip{
            top:4px;
            left: 0;
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50px;
            background: red;
        }
    }
</style>